import React, { useContext, useState, useEffect } from "react";
import { Col, Container, Row, Button, Form } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { SessionContext } from "../SessionProvider";
import PageNavigations from "../breadcrumbs/PageNavigations";
import { Helmet } from "react-helmet";
import schoolApi from "../../api/schoolApi";
import moment from "moment/moment";
import CityState from "../../constants/CityState.json";
import { set } from "date-fns";
import Confirm from "../Confirm";

const StaffEdit = (props) => {
  const { selectedSessionId } = useContext(SessionContext);
  const location = useLocation();
  const navigate = useNavigate();

  // Consolidated State
  const [contact, setContact] = useState({
    recordtype: null,
    salutation: null,
    firstname: null,
    lastname: null,
    phone: null,
    session_id: selectedSessionId,
    dateofbirth: null,
    experience: 0,
    adharnumber: null,
    qualification: null,
    classid: null,
    parentid: null,
    email: null,
    gender: null,
    street: null,
    pincode: null,
    country: null,
    state: null,
    city: null,
    religion: null,
    status: true,
    previousEmployers: [
      {
        employer_name: "",
        phone: null,
        email: null,
        start_date: null,
        end_date: null,
        experienceLetter: null,
      },
    ],
    image: null,
    aadharCard: null,
    panCard: null,
    drivingLicense: null,
  });

  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [errors, setErrors] = useState({});
  const [sessionYear, setSessionYear] = useState([]);
  const [isApiResponse, setIsApiResponse] = useState(false);
  const [employerIds, setEmployerId] = useState([]);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [rowData, setRowData] = useState();

  // Regex Patterns
  const regex = {
    name: /^[A-Za-z\s]{2,50}$/,
    email: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
    aadhar: /^\d{12}$/,
    pincode: /^\d{6}$/,
  };

  useEffect(() => {
    if (!location?.state?.id) {
      console.log("hjdajsfjkuer=>", selectedSessionId);
      setContact((prev) => ({ ...prev, session_id: selectedSessionId }));
    }
  }, [!location?.state?.id]);

  useEffect(() => {
    async function getSessions() {
      try {
        const sessions = await schoolApi.fetchSessions();
        console.log("sessions data == ", sessions);
        if (sessions.success) {
          setSessionYear(sessions.result);
        } else {
          setSessionYear([]);
        }
      } catch (err) {
        toast.error("An error occurred while fetching sessions.");
        setSessionYear([]);
      }
    }
    getSessions();
  }, []);

  useEffect(() => {
    const uniqueStates = Array.from(
      new Set(CityState.map((item) => item.state))
    )
      .map((state) => ({ label: state, value: state }))
      .sort((a, b) => a.label.localeCompare(b.label));

    setStates(uniqueStates);

    setStates(uniqueStates);
  }, [CityState]);

  useEffect(() => {
    if (location?.state) {
      console.log("location.state==>>", location.state);
      setContact(location.state);
    } else {
      if (location.hasOwnProperty("pathname")) {
        contact.session_id = selectedSessionId;
        if (props?.selectedRecordType === "driver") {
          setContact({
            ...contact,
            recordtype: "Driver",
            department: "driver",
          });
        }
      }
    }

    if (location?.state?.id) {
      const selectedState = states.find(
        (state) => state.value === location.state.state
      );
      setSelectedState(selectedState);

      const filteredCities = CityState.filter(
        (item) => item.state === location.state.state
      )
        .map((city) => ({ label: city.name, value: city.name }))
        .sort((a, b) => a.label.localeCompare(b.label));

      setCities(filteredCities);

      const selectedCity = filteredCities.find(
        (city) => city.value === location.state.city
      );

      setSelectedCity(selectedCity);
    } else {
      setSelectedState(null);
      setSelectedCity(null);
      setCities([]);
    }
  }, [location, states]);

  const handleStateChange = (e) => {
    setSelectedState(e.target.value);
    setSelectedCity(null);
    setCities(
      CityState.filter((item) => item.state === e.target.value)
        .map((city) => ({
          label: city.name,
          value: city.name,
        }))
        .sort((a, b) => a.label.localeCompare(b.label))
    );
    setContact({ ...contact, state: e.target.value });
  };

  // Handle City Change
  const handleCityChange = (e) => {
    setContact((prev) => ({ ...prev, city: e.target.value }));
  };

  // Handle Employee Details Change
  const handleChange = (e) => {
    let { name, value } = e.target;

    if (name === "phone") {
      value = value.replace(/\D/g, "").slice(0, 10);
    } else if (name === "adharnumber") {
      value = value.replace(/\D/g, "").slice(0, 12);
    } else if (name === "experience") {
      value = value.replace(/\D/g, "");
      // if (value !== "" && (parseInt(value) < 0 || parseInt(value) > 99)) {
      //     value = 0;
      // }
    }

    validateField(name, value);
    setContact((prev) => ({ ...prev, [name]: value }));
  };

  // Validate Field
  const validateField = (name, value) => {
    let error = "";
    switch (name) {
      case "firstname":
      case "lastname":
        if (!regex.name.test(value)) {
          error = "Name should contain only alphabets and be 2-50 characters long.";
        }
        break;
      case "adharnumber":
        if (value && !regex.aadhar.test(value)) {
          error = "Aadhar number must be 12 digits.";
        }
        break;
      case "phone":
        if (!/^\d{10}$/.test(value)) {
          error = "Phone number must be exactly 10 digits.";
        }
        break;
      case "email":
        if (value && !regex.email.test(value)) {
          error = "Invalid email address.";
        }
        break;
      case "pincode":
        if (value && !regex.pincode.test(value)) {
          error = "Pincode must be 6 digits.";
        }
        break;
      case "experience":
        if (value && (isNaN(value) || value < 0 || value > 99)) {
          error = "Experience must be a number between 0 and 99.";
        }
        break;
      default:
        break;
    }
    setErrors((prev) => ({ ...prev, [name]: error }));
  };

  // Handle Previous Employer Change
  const handleEmployerChange = (index, e) => {
    let { name, value, type, files } = e.target;

    if (name === "phone") {
      value = value.replace(/\D/g, "").slice(0, 10);
    }

    if (type === "file" && files[0]) {
      const allowedPdfFields = ["experienceLetter"];
      const isPdf = files[0].type === "application/pdf";

      if (allowedPdfFields.includes(name) && !isPdf) {

        setContact((prev) => {
          const updatedEmployers = [...prev.previousEmployers];
          updatedEmployers[index][name] = null;
          return { ...prev, previousEmployers: updatedEmployers };
        });
        e.target.value = null;
        return toast.error(`Experience Letter must be a PDF file.`);      }

      setContact((prev) => {
        const updatedEmployers = [...prev.previousEmployers];
        updatedEmployers[index][name] = files[0];
        return { ...prev, previousEmployers: updatedEmployers };
      });
    } else {
      setContact((prev) => {
        const updatedEmployers = [...prev.previousEmployers];
        updatedEmployers[index][name] = value;
        return { ...prev, previousEmployers: updatedEmployers };
      });
    }
    validateEmployerField(index, name, value);
  };

  // Validate Employer Field
  const validateEmployerField = (index, name, value) => {
    let error = "";

    switch (name) {
      case "employer_name":
        if (!regex.name.test(value)) {
          error =
            "Employer name should contain only alphabets and be 2-50 characters long.";
        }
        break;
      case "phone":
        if (!/^\d{10}$/.test(value)) {
          error = "Invalid phone number, must be a 10-digit Indian number.";
        }
        break;
      case "email":
        if (value && !regex.email.test(value)) {
          error = "Invalid email address.";
        }
        break;
      default:
        break;
    }

    setErrors((prev) => {
      const newErrors = { ...prev };

      if (error) {
        newErrors[`employer_${index}_${name}`] = error;
      } else {
        delete newErrors[`employer_${index}_${name}`]; // Remove error if valid
      }

      return newErrors;
    });
  };


  const handleEmployerDateChange = (index, date, field) => {
    if (!date) {
      return;
    }

    const localDate = new Date(date);
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset time to avoid time comparison issues

    if (localDate > today) {
      return toast.error("Date cannot be in the future.");
    }

    const formattedDate = `${localDate.getFullYear()}-${String(
      localDate.getMonth() + 1
    ).padStart(2, "0")}-${String(localDate.getDate()).padStart(2, "0")}`;

    setContact((prev) => {
        const updatedEmployers = [...prev.previousEmployers];
        const employer = updatedEmployers[index];

        if (field === "end_date" && employer.start_date) {
            const startDate = new Date(employer.start_date);
            if (localDate <= startDate) {
                  // alert("End date should be greater than the start date.");
                  toast.error("End date should be greater than the start date.")
                  return prev; // Prevent updating state
            }
        }

        if (field === "start_date" && employer.end_date) {
            const endDate = new Date(employer.end_date);
            if (localDate >= endDate) {
                  // alert("Start date should be less than the end date.");
                  toast.error("Start date should be less than the end date.");
                  return prev; // Prevent updating state
            }
        }

        updatedEmployers[index][field] = formattedDate; // Store in YYYY-MM-DD format

        return { ...prev, previousEmployers: updatedEmployers };
    });
};

  // Add New Employer
  const addEmployer = () => {
    setContact((prev) => ({
      ...prev,
      previousEmployers: [
        ...(prev.previousEmployers || []),
        {
          employer_name: "",
          phone: null,
          email: null,
          start_date: null,
          end_date: null,
          experienceLetter: null,
        },
      ],
    }));
  };

  // Remove Employer
  const removeEmployer = (index, employer_id) => {
    setRowData({ index, employer_id })
    setShowConfirmModal(true);
  };

  const handleConfirmRemoveEmployerItem = () => {

    //   if(contact.previousEmployers.length > 1){ 
    setEmployerId((prev) => [...prev, rowData?.employer_id]);

    setContact((prev) => ({
      ...prev,
      previousEmployers: prev.previousEmployers.filter((_, i) => i !== rowData?.index),
    }));

    setRowData(null)
    // }
  }

  const handleDocumentUpload = (e, field) => {
    const file = e.target.files[0];
    if (!file) return;

    const fieldNamesMap = {
      aadharCard: "Aadhar Card",
      panCard: "Pan Card",
      drivingLicense: "Driving License",
      image: "Profile Image"
    };

    const displayFieldName = fieldNamesMap[field] || field;

    const allowedPdfFields = ["aadharCard", "panCard", "drivingLicense"];
    const allowedImageFields = ["image"];
    const isPdf = file.type === "application/pdf";
    const isImage = ["image/jpeg", "image/png", "image/jpg"].includes(file.type);

    let error = "";

    if (allowedPdfFields.includes(field) && !isPdf) {

      toast.error(`${displayFieldName} must be a PDF file.`);
      error = `${displayFieldName} must be a PDF file.`;

    } else if (allowedImageFields.includes(field) && !isImage) {

      toast.error(`${displayFieldName} must be a JPG, JPEG, or PNG file.`);
      error = `${displayFieldName} must be a JPG, JPEG, or PNG file.`;
    }

    if (file.size > 5 * 1024 * 1024) {
      return toast.error("File size must be less than 5MB.");
    }

    if (error) {
      setErrors((prev) => ({
        ...prev,
        [field]: error,
      }));

      // make feild empty on UI and in State!
      e.target.value = null;
      setContact((prev) => ({
        ...prev,
        [field]: null,
      }));

      return;
    }

    setErrors((prev) => {
      const newErrors = { ...prev };
      delete newErrors[field];
      return newErrors;
    });

    setContact((prev) => ({
      ...prev,
      [field]: file,
    }));
  };


  const validateForm = () => {
    let isValid = true;
    const newErrors = {};

    // Validate Employee Details
    if (contact?.recordtype?.trim() === "") {
      newErrors.recordtype = "Record type is required and must be valid.";
      isValid = false;
    }

    if (!contact.firstname || !regex.name.test(contact.firstname)) {
      newErrors.firstname = "First name is required and must be valid.";
      isValid = false;
    }
    if (!contact.lastname || !regex.name.test(contact.lastname)) {
      newErrors.lastname = "Last name is required and must be valid.";
      isValid = false;
    }

    if (contact.phone && !/^\d{10}$/.test(contact.phone)) {
      newErrors.phone = "Phone number must be exactly 10 digits.";
      isValid = false;
    } else if (!contact.phone) {
      newErrors.phone = "Phone number is required and must be valid.";
      isValid = false;
    }

    if (!contact?.dateofbirth) {
      newErrors.dateofbirth = "Date of birth is required.";
      isValid = false;
    } else {
      const dob = new Date(contact?.dateofbirth);
      if (isNaN(dob) || dob > new Date()) {
        newErrors.dateofbirth = "Date of birth must be in the past.";
        isValid = false;
      }
    }

    if (contact?.email && !regex?.email?.test(contact?.email)) {
      newErrors.email = "Invalid email address.";
      isValid = false;
    }

    if (contact?.experience && (isNaN(contact?.experience) || contact?.experience < 0 || contact?.experience > 99)) {
      newErrors.experience = "Experience must be a number between 0 and 99.";
      isValid = false;
    }

    // if(!contact?.status){
    //   newErrors.status = "Status is required field.";
    //   isValid = false;
    // }

    if(contact.status === null || contact.status === undefined || contact.status === ""){
      newErrors.status = "Status is required field.";
      isValid = false;
    }

    setErrors(newErrors);

    if (contact?.previousEmployers?.length) {
      let employerErrorsArray = contact.previousEmployers.map((employer, index) => {
          let employerErrors = {};
  
          if (employer.phone && !/^\d{10}$/.test(employer.phone) ) {
              employerErrors[`employer_${index}_phone`] = "Invalid phone number, must be a 10-digit Indian number.";
              isValid = false;
          }
  
          if (employer.email && !regex.email.test(employer.email)) {
              employerErrors[`employer_${index}_email`] = "Invalid email address.";
              isValid = false;
          }
  
          return Object.keys(employerErrors).length ? employerErrors : null;
      }).filter(error => error !== null); // Remove null values from the array
  
      console.log('employerErrorsArray-->>' , employerErrorsArray);
      
      setErrors((prev) => {
        const newErrors = { ...prev };
    
        if (employerErrorsArray.length > 0) {
            employerErrorsArray.forEach((errors) => {
                Object.entries(errors).forEach(([key, message]) => {
                    console.log('Setting error for:', key, 'Message:', message);
                    newErrors[key] = message;
                });
            });
        }
    
        return newErrors;
    });
    
    }

    return isValid;
  };

  const handleCancel = () => {
    const recordType = contact?.recordtype || location?.state?.recordtype;
    const contactId = contact?.id;

    if (contactId) {
      navigate(
        `/${recordType === "Driver" ? "driver" : "staff"}/${contactId}`,
        { state: contact }
      );
    } else {
      navigate(`/${recordType === "Driver" ? "driver" : "staffs"}`);
    }
  };

  const handleSubmit = async (e) => {
    console.log("handleSubmit-employee-->>", contact);
    e.preventDefault();

    if (!validateForm()) {
      return toast.error("Missing required field.");
    }

    setIsApiResponse(true);

    let result2 = {};
    console.log("contact-data-->>", contact);

    if (contact.id) {
      try {

        if (employerIds?.length > 0 && employerIds?.every((item) => item !== 'undefined' && item !== undefined)) {
          /* delete employer from DB */
          const employerRecordDeleteResult = await schoolApi.deleteEmployerById(employerIds);
          console.log('employerRecordDeleteResult@@-->>', employerRecordDeleteResult);
        }

        contact.dateofbirth = moment(contact?.dateofbirth).format("YYYY-MM-DD");
        // result2 = await schoolApi.saveContact(contact);
        if (contact.previous_employer) {
          delete contact.previous_employer;
        }

        result2 = await schoolApi.updateEmployeeWithDocument(contact);
        console.log("result2-->>", result2);
        if (result2.success) {
          toast.success("Record updated successfully");
          setTimeout(() => {
            if (contact.recordtype === "Driver") {
              navigate(`/driver/${contact.id}`, { state: result2.contactRec });
            } else {
              navigate(`/staff/${contact.id}`, { state: result2.contactRec });
            }
          }, 2000);
        } else {
          console.log("result2s-else-->>", result2);
          toast.error(result2?.message);
        }
      } catch (error) {
        setIsApiResponse(false);
        console.log("error-->>", error);
        if (error.response.data.message && error.response.data)
          toast.error(error.response.data.message);
        else toast.error("Something went wrong!!");
      }
    } else {
      try {
        result2 = await schoolApi.createContactwithdoc(contact);
        if (result2.success) {
          toast.success("Record created succesfully");
          setTimeout(() => {
            if (result2.contactRec.recordtype === "Driver") {
              navigate(`/driver/${result2.contactRec.id}`, {
                state: result2.contactRec,
              });
            } else {
              navigate(`/staff/${result2.contactRec.id}`, {
                state: result2.contactRec,
              });
            }
          }, 2000);
        } else {
          toast.error(result2.message);
        }
      } catch (error) {
        setIsApiResponse(false);
        if (error.response.data.message && error.response.data)
          toast.error(error.response.data.message);
        else toast.error("Something went wrong!!");
      }
    }
  };

  function bufferToUrl(bufferData, type) {
    const uint8Array = new Uint8Array(bufferData);
    const blob = new Blob([uint8Array], { type });
    return URL.createObjectURL(blob);
  }

  return (
    <>
      <Helmet><title>{props?.tabName}</title></Helmet>
      <PageNavigations
        id={location.state?.id}
        listName={
          props?.selectedRecordType === "staff"
            ? "Create New Employee"
            : props?.selectedRecordType === "driver"
              ? "Create New Driver"
              : ""
        }
        listPath={
          location?.pathname?.split("/")[1] === "/staffs" ||
            location?.pathname?.split("/")[1] === "/driver"
            ? ""
            : "/staffs"
        }
        viewName={
          props?.selectedRecordType === "driver" ? "Staff View" : "Employee Edit"
        }
        viewPath={"/staff/" + location.state?.id}
        colLg={10}
        colClassName="d-flex px-3 py-2"
        extrColumn={2}
      />

      <Container className="view-form mb-5">
        <Row>
          <Col lg={12}>
            <Form onSubmit={handleSubmit}>
              <Row
                className="view-form-header align-items-center"
                style={{ marginLeft: "1.1%", marginRight: "1.1%" }}
              >
                <Col lg={3}>Employee Details</Col>
                <Col lg={9} className="d-flex justify-content-end">
                  <Button className="btn-sm mx-2" onClick={handleSubmit} disabled={isApiResponse}>
                    {location?.state?.id ? "Update" : "Save"}
                  </Button>
                  <Button
                    className="btn-sm"
                    variant="danger"
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                </Col>
              </Row>

              <Row>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label>Employee Type</Form.Label>
                    <Form.Select
                      required
                      name="recordtype"
                      onChange={handleChange}
                      isInvalid={!!errors.recordtype}
                      value={contact.recordtype}
                      disabled={location.pathname === "/driver/e"}
                    >
                      <option value="">--Select Employee Type--</option>
                      <option value="Principal">Principal</option>
                      <option value="Teacher">Teacher</option>
                      <option value="Admin">Admin</option>
                      <option value="Librarian">Librarian</option>
                      <option value="Accountant">Accountant</option>
                      <option value="Driver">Driver</option>
                      <option value="Peon">Peon</option>
                      <option value="Security Guard">Security Guard</option>
                      <option value="PTI">PTI</option>
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      {errors.recordtype}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label>Salutation</Form.Label>
                    <Form.Select
                      name="salutation"
                      value={contact.salutation}
                      onChange={handleChange}
                      isInvalid={!!errors.salutation}
                    >
                      <option value="">-- Select Salutation --</option>
                      <option value="Mr">Mr.</option>
                      <option value="Ms">Ms.</option>
                      <option value="Mrs">Mrs.</option>
                      <option value="Dr">Dr.</option>
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      {errors.salutation}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label>First Name</Form.Label>
                    <Form.Control
                      type="text"
                      required
                      name="firstname"
                      value={contact.firstname}
                      onChange={handleChange}
                      placeholder="Enter First Name"
                      isInvalid={!!errors.firstname}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.firstname}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label>Last Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="lastname"
                      required
                      value={contact.lastname}
                      onChange={handleChange}
                      placeholder="Enter Last Name"
                      isInvalid={!!errors.lastname}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors?.lastname}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label>Date of Birth</Form.Label>
                    <DatePicker
                      required
                      selected={contact?.dateofbirth ? new Date(contact.dateofbirth) : null}
                      onChange={(date) => {
                        const today = new Date();
                        today.setHours(0, 0, 0, 0);

                        if (date > today) {
                          return toast.error("Date of Birth cannot be in the future.");
                        }

                        setContact((prev) => ({
                          ...prev,
                          dateofbirth: date,
                        }));
                      }}
                      dateFormat="dd/MM/yyyy"
                      className={`form-control ${errors.dateofbirth ? "is-invalid" : ""
                        }`}
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      placeholderText="Select a date"
                      onKeyDown={(e) => e.preventDefault()}
                    />
                    {errors.dateofbirth && (
                      <div className="invalid-feedback d-block">
                        {errors.dateofbirth}
                      </div>
                    )}
                  </Form.Group>
                </Col>

                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label>Gender</Form.Label>
                    <Form.Select
                      name="gender"
                      value={contact.gender}
                      onChange={handleChange}
                      isInvalid={!!errors.gender}
                    >
                      <option value="">-- Select Gender --</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Other">Other</option>
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      {errors.gender}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label>Phone</Form.Label>
                    <Form.Control
                      type="text"
                      required
                      name="phone"
                      value={contact.phone}
                      onChange={handleChange}
                      placeholder="Enter Phone"
                      isInvalid={!!errors.phone}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.phone}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      value={contact.email}
                      onChange={handleChange}
                      placeholder="Enter Email"
                      isInvalid={!!errors.email}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.email}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label>Religion</Form.Label>
                    <Form.Select
                      value={contact.religion}
                      onChange={(e) =>
                        setContact((prev) => ({
                          ...prev,
                          religion: e.target.value,
                        }))
                      }
                    >
                      <option value="">Select Religion</option>
                      <option value="Hindu">Hindu</option>
                      <option value="Muslim">Muslim</option>
                      <option value="Christian">Christian</option>
                      <option value="Sikh">Sikh</option>
                      <option value="Buddhist">Buddhist</option>
                      <option value="Jain">Jain</option>
                      <option value="Other">Other</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label>Aadhar Number</Form.Label>
                    <Form.Control
                      type="text"
                      name="adharnumber"
                      value={contact?.adharnumber}
                      onChange={handleChange}
                      placeholder="Enter Aadhar Number"
                      isInvalid={!!errors.adharnumber}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.adharnumber}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label>Qualification</Form.Label>
                    <Form.Control
                      type="text"
                      name="qualification"
                      value={contact.qualification}
                      onChange={handleChange}
                      placeholder="Enter Qualification"
                    />
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label>Total Experience (in years)</Form.Label>
                    <Form.Control
                      type="text"
                      name="experience"
                      value={contact?.experience}
                      onChange={handleChange}
                      placeholder="Enter total experience"
                      isInvalid={!!errors.experience}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.experience}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">State</Form.Label>
                    <Form.Select
                      name="state"
                      value={contact?.state}
                      onChange={handleStateChange}
                    >
                      <option value="">-- Select State --</option>
                      {states.map((state) => (
                        <option key={state.label} value={state.value}>
                          {state.label}
                        </option>
                      ))}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      {errors.state}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label>City</Form.Label>
                    <Form.Select
                      name="city"
                      value={contact?.city}
                      onChange={handleCityChange}
                      isInvalid={!!errors.city}
                      disabled={!contact.state}
                    >
                      <option value="">-- Select City --</option>
                      {cities.map((city) => (
                        <option key={city.label} value={city.value}>
                          {city.label}
                        </option>
                      ))}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      {errors.city}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label>Country</Form.Label>
                    <Form.Control
                      type="text"
                      name="country"
                      placeholder="Enter your Country"
                      value={contact?.country}
                      onChange={handleChange}
                      isInvalid={!!errors.country}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.country}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label>Street</Form.Label>
                    <Form.Control
                      type="text"
                      name="street"
                      value={contact.street}
                      onChange={handleChange}
                      placeholder="Enter Street"
                      isInvalid={!!errors.street}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.street}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label>Pincode</Form.Label>
                    <Form.Control
                      type="text"
                      name="pincode"
                      value={contact.pincode}
                      onChange={handleChange}
                      placeholder="Enter Pincode"
                      isInvalid={!!errors.pincode}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.pincode}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label>Status</Form.Label>
                    <Form.Select
                      name="status"
                      required
                      value={contact?.status === true ? "active" : "inactive"}
                      onChange={(e) =>
                        setContact((prev) => ({
                          ...prev,
                          status: e.target.value === "active",
                        }))
                      }
                      isInvalid={!!errors.status}
                    >
                      <option value="" disabled>-- Select Status --</option>
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      {errors.status}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>

              <br />
              <hr />

              <h4 className="mt-4">Previous Employer</h4>
              {contact?.previousEmployers?.map((employer, index) => (
                <div key={index} className="mb-4 p-3 border rounded shadow-sm bg-light">
                  <Row className="g-3">
                    <Col lg={4}>
                      <Form.Group>
                        <Form.Label>Employer Name</Form.Label>
                        <Form.Control
                          type="text"
                          name="employer_name"
                          value={employer.employer_name || ""}
                          onChange={(e) => handleEmployerChange(index, e)}
                          placeholder="Enter Employer Name"
                        />
                      </Form.Group>
                    </Col>

                    <Col lg={4}>
                      <Form.Group>
                        <Form.Label>Phone</Form.Label>
                        <Form.Control
                          type="text"
                          name="phone"
                          value={employer.phone ? employer.phone : ""}
                          onChange={(e) => handleEmployerChange(index, e)}
                          placeholder="Enter Phone"
                          isInvalid={!!errors[`employer_${index}_phone`]}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors[`employer_${index}_phone`]}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={4}>
                      <Form.Group>
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          value={employer.email ? employer.email : ""}
                          onChange={(e) => handleEmployerChange(index, e)}
                          placeholder="Enter Email"
                          isInvalid={!!errors[`employer_${index}_email`]}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors[`employer_${index}_email`]}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="g-3 mt-1">
                    <Col lg={4}>
                      <Form.Group>
                        <Form.Label>Start Date</Form.Label>
                        <DatePicker
                          selected={employer?.start_date ? moment(employer?.start_date?.split("T")[0], "YYYY-MM-DD").toDate() : employer?.start_date}
                          onChange={(date) => handleEmployerDateChange(index, date, "start_date")}
                          dateFormat="dd/MM/yyyy"
                          className="form-control"
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          placeholderText="Select Start Date"
                          maxDate={employer?.end_date && new Date(employer?.end_date)}
                        />
                      </Form.Group>
                    </Col>

                    <Col lg={4}>
                      <Form.Group>
                        <Form.Label>End Date</Form.Label>
                        <DatePicker
                          selected={employer?.end_date ? moment(employer?.end_date?.split("T")[0], "YYYY-MM-DD").toDate() : employer?.end_date}
                          onChange={(date) => handleEmployerDateChange(index, date, "end_date")}
                          dateFormat="dd/MM/yyyy"
                          className="form-control"
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          placeholderText="Select End Date"
                          minDate={employer?.start_date && new Date(employer?.start_date)}
                        />
                      </Form.Group>
                    </Col>

                    <Col lg={4}>
                      <Form.Group>
                        <Form.Label>Experience Letter (Optional)</Form.Label>
                        <Form.Control
                          name="experienceLetter"
                          accept=".pdf" // Allow only PDF files
                          type="file"
                          onChange={(e) => handleEmployerChange(index, e)}
                        />
                      </Form.Group>
                      {(employer?.experience_letter || employer?.experienceLetter) && (
                        <Form.Text className="text-muted mx-2">
                          <a
                            href={employer?.experienceLetter
                              ? URL.createObjectURL(employer?.experienceLetter)
                              : bufferToUrl(employer?.experience_letter?.data, "application/pdf")
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className="fa-solid fa-file-pdf mx-2" style={{ fontSize: "15px" }}></i>
                            View PDF
                          </a>
                        </Form.Text>
                      )}
                    </Col>
                  </Row>

                  {/* Delete Button */}
                  {/* <div className="d-flex justify-content-end mt-3 g-2">
                    
              <Button variant="success" onClick={addEmployer} className="mb-1">
                <i className="fa fa-plus"></i>
              </Button>
                    <Button variant="danger" disabled={contact.previousEmployers.length === 1} onClick={() => removeEmployer(index , employer?.id)}>
                      <i className="fa fa-trash"></i>
                    </Button>
                  </div>
                   */}

                  <div className="d-flex justify-content-end mt-3">
                    <Button variant="success" onClick={addEmployer} className="mx-2">
                      <i className="fa fa-plus"></i>
                    </Button>
                    <Button variant="danger" disabled={contact?.previousEmployers?.length <= 1} onClick={() => removeEmployer(index, employer?.id)}>
                      <i className="fa fa-trash"></i>
                    </Button>
                  </div>

                </div>
              ))}

              {(contact?.id && !contact?.previousEmployers) &&
                <Button variant="success" onClick={addEmployer} className="mb-1">
                  <i className="fa fa-plus"></i>
                </Button>
              }

              <br />
              <hr />

              <h4 className="mt-3">Documents</h4>
              <div className="p-4 border rounded shadow-sm bg-light">
                <Row className="g-3">
                  <Col lg={4}>
                    <Form.Group className="mx-3">
                      <Form.Label>Image</Form.Label>
                      <Form.Control
                        accept="image/*" // Allow only image files
                        type="file"
                        onChange={(e) => handleDocumentUpload(e, "image")}
                      />
                    </Form.Group>
                    {(contact?.profile_image || contact?.image) && (
                      <Form.Text className="text-muted mx-2">
                        <a
                          href={contact?.image ? URL.createObjectURL(contact?.image) : bufferToUrl(contact?.profile_image?.data, "image/png")}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fa-solid fa-file-pdf mx-2" style={{ fontSize: "15px" }}></i>
                          View Profile
                        </a>
                      </Form.Text>
                    )}
                  </Col>
                  <Col lg={4}>
                    <Form.Group className="mx-3">
                      <Form.Label>Aadhar Card</Form.Label>
                      <Form.Control
                        accept=".pdf" // Allow only PDF files
                        type="file"
                        onChange={(e) => handleDocumentUpload(e, "aadharCard")}
                      />
                    </Form.Group>
                    {(contact?.aadhar_card || contact?.aadharCard) && (
                      <Form.Text className="text-muted mx-2">
                        <a
                          href={contact?.aadharCard ? URL.createObjectURL(contact?.aadharCard) : bufferToUrl(contact?.aadhar_card?.data, "application/pdf")}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fa-solid fa-file-pdf mx-2" style={{ fontSize: "15px" }}></i>
                          View PDF
                        </a>
                      </Form.Text>
                    )}
                  </Col>
                  <Col lg={4}>
                    <Form.Group className="mx-3">
                      <Form.Label>PAN Card</Form.Label>
                      <Form.Control
                        type="file"
                        accept=".pdf" // Allow only PDF files
                        onChange={(e) => handleDocumentUpload(e, "panCard")}
                      />
                    </Form.Group>
                    {(contact?.pan_card || contact?.panCard) && (
                      <Form.Text className="text-muted mx-2">
                        <a
                          href={contact?.panCard ? URL.createObjectURL(contact?.panCard) : bufferToUrl(contact?.pan_card?.data, "application/pdf")}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fa-solid fa-file-pdf mx-2" style={{ fontSize: "15px" }}></i>
                          View PDF
                        </a>
                      </Form.Text>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col lg={4}>
                    <Form.Group className="mx-3">
                      <Form.Label>Driving License</Form.Label>
                      <Form.Control
                        type="file"
                        accept=".pdf" // Allow only PDF files
                        onChange={(e) =>
                          handleDocumentUpload(e, "drivingLicense")
                        }
                      />
                    </Form.Group>
                    {(contact?.driving_license || contact?.drivingLicense) && (
                      <Form.Text className="text-muted mx-2">
                        <a
                          href={contact?.drivingLicense ? URL.createObjectURL(contact?.drivingLicense) : bufferToUrl(contact?.driving_license?.data, "application/pdf")}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fa-solid fa-file-pdf mx-2" style={{ fontSize: "15px" }}></i>
                          View PDF
                        </a>
                      </Form.Text>
                    )}
                  </Col>
                </Row>
              </div>
            </Form>
          </Col>
        </Row>
        <ToastContainer />
      </Container>

      {showConfirmModal && (
        <Confirm
          show={showConfirmModal}
          onHide={() => setShowConfirmModal(false)}
          handleRmployerRemove={() => handleConfirmRemoveEmployerItem()}
          title="Confirm remove employer?"
          message="Are you sure want to remove employer record ?"
          table="employer_confirm"
        />
      )}
    </>
  );
};
export default StaffEdit;